/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-30 10:06:44
 * @LastEditors: K
 * @LastEditTime: 2022-10-08 16:28:28
 */
import { ADMIN_API_PREFIX, API_PREFIX } from './constant'
import { Request } from './request'
export interface getMembersPageFnParams {
  size?: number
  current?: number
  endTime?: string
  startTime?: any
  labelIds?: string
  keyWord?: any
  // 排序字段
  memberNameSort?: number
  cardNoSort?: number
  balanceMoneySort?: number
  createTimeSort?: number
}
//  会员管理-列表
export const getMembersPageFn = (params: getMembersPageFnParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/memberPage`,
    method: 'GET',
    params,
  }
}

//  会员管理-新增
export interface getAddMembersFnParams {
  age?: string
  balanceMoney?: number
  birthday?: string
  createUser?: string
  labelIds?: string
  memberName?: string
  memberPhone?: number
  remarks?: string
  sexType?: string
  patientId?: number
  ageYear?: number
  ageMonth?: number
  idCardNumber?: string
}
export const getAddMembersFn = (body: getAddMembersFnParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/saveMember`,
    method: 'POST',
    body,
  }
}

export const getMembersDetailFn = (memberId: any): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getMemberOne`,
    method: 'GET',
    params: { memberId },
  }
}

//  会员管理-新增会员-操作人
export const getAddMembersOperationFn = (): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getCreateList`,
    method: 'GET',
  }
}
//  会员管理-会员基础信息
export interface getMembersBaseInfoFnParams {
  memberId?: number
}
export const getMembersBaseInfoFn = (
  params: getMembersBaseInfoFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getMemberBasicsDetails`,
    method: 'GET',
    params,
  }
}
//  会员管理-充值 or 退款详情信息
export const getMembersInfoFn = (
  params: getMembersBaseInfoFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getMemberDetails`,
    method: 'GET',
    params,
  }
}
//  会员管理-充值 or 退款
export interface getMembersTopUpFnParams {
  createUser?: string
  memberId?: number
  money?: number
  remark?: string
  type?: number
}
export const getMembersTopUpFn = (body: getMembersTopUpFnParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/rechargeRefund`,
    method: 'POST',
    body,
  }
}
//  会员管理-充值记录
export interface getMembersTopUpRecordFnParams {
  memberId?: number
  current?: number
  size?: number
  type?: number
}
export const getMembersTopUpRecordFn = (
  params: getMembersTopUpRecordFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/getRechargeList`,
    method: 'GET',
    params,
  }
}
//  药品零售-搜索会员
export interface getSearchMembersFnParams {
  memberPhone?: number
}
export const getSearchMembersFn = (
  params: getSearchMembersFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/searchMember`,
    method: 'GET',
    params,
  }
}

// 会员管理-搜索会员-通过会员卡号
export const getSearchMembersByCardNoFn = (
  params: getSearchMembersFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/member/searchMemberOrMemberCard`,
    method: 'GET',
    params,
  }
}



//  药品零售-搜索会员
export interface AddOrEditMemberCardFnParams {
  balance?: any
  cardNo?: any
  remark?: any
  cardType?: number
  id?: any
}
export const getAddMemberCardFn = (
  body: AddOrEditMemberCardFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/addMemberCard`,
    method: 'POST',
    body,
  }
}

// 会员卡编辑
export const getEditMemberCardFn = (
  body: AddOrEditMemberCardFnParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/update`,
    method: 'POST',
    body,
  }
}

// 会员卡编辑详情
export interface EditMemberCardParams {
  memberCardId?: number
}
export const getEditMemberCardDetailFn = (
  params: EditMemberCardParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/detail`,
    method: 'GET',
    params,
  }
}

// 会员卡删除
export interface DeleteMemberCardParams {
  id?: number
}
export const deleteMemberCardFn = (
  body: DeleteMemberCardParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/delete`,
    method: 'POST',
    body,
  }
}
// 会员卡解绑
export interface UnbindMemberCardParams {
  memberCardId?: number
}
export const unbindMemberCardFn = (
  body: UnbindMemberCardParams
): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/unBindMemberCard`,
    method: 'POST',
    body,
  }
}
// 会员卡绑定
export interface BindMemberParams {
  memberCardId?: any
  memberId?: any
  pageName?: any
}
export const bindMemberFn = (body: BindMemberParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/memberCardBind`,
    method: 'POST',
    body,
  }
}
// 会员卡列表
export interface MemberCardListParams {
  current?: number
  size?:any
  bindState?: any
  param?: any
  timeHead?: any
  timeTail?: any
}
export const getMemberCardListFn = (params: MemberCardListParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/page`,
    method: 'GET',
    params,
  }
}

 export const getMemberCardSearchListFn = (params: MemberCardListParams): Request => {
  return {
    url: `${API_PREFIX}/blade-outpatient/membercard/selectMemberCardWithNoBind`,
    method: 'GET',
    params,
  }
}